var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"content-layout",attrs:{"column":""}},[_c('label',{staticClass:"secondary--text display-1 font-weight-bold"},[_vm._v("Покупатели")]),_c('users-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }